// <--- Styles Start --->
import styled from "styled-components";
// <--- Styles End --->

export const ShareWithSectionStyled = styled.div``;
